import { useState, useEffect } from 'react';
import { backgroundSync } from '@/lib/services/background-sync-service';

type SyncStatus = {
  inProgress: boolean;
  lastSyncTime: number | null;
  progress: number;
  error: Error | null;
};

// Custom hook for components to use sync status
export const useSyncStatus = () => {
  const [status, setStatus] = useState<SyncStatus>({
    inProgress: false,
    lastSyncTime: null,
    progress: 0,
    error: null
  });
  
  useEffect(() => {
    // Get initial status
    setStatus(backgroundSync.getStatus());
    
    // Subscribe to status updates
    const unsubscribe = backgroundSync.addListener(newStatus => {
      setStatus(newStatus);
    });
    
    return unsubscribe;
  }, []);
  
  return {
    ...status,
    syncNow: () => backgroundSync.syncNow(),
    scheduleSync: (type?: 'normal' | 'priority') => backgroundSync.scheduleSync(type)
  };
};
